export default __webpack_public_path__ + "static/media/loading.522e08c1.gif";